<template>
    <a-button @click="onClick" htmlType="submit" type="primary" class="button-submit">
        <slot></slot>
    </a-button>
</template>

<script>
export default {
    methods: {
        onClick() {
            this.$emit('click');
        },
    },
};
</script>
